import { render, staticRenderFns } from "./LostPayments.vue?vue&type=template&id=d34113a8&"
import script from "./LostPayments.vue?vue&type=script&lang=js&"
export * from "./LostPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports